import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { translation } from '@cue/translations';
import { cueQrCode, IconComponent } from '@cue/ui/icons';
import { TranslocoPipe } from '@jsverse/transloco';

import { Subscription } from 'rxjs';
import { QRService } from '@cue/utilities';

@Component({
  selector: 'assist-layout-scan-button',
  imports: [TranslocoPipe, IconComponent],
  templateUrl: './layout-scan-button.component.html',
  styleUrls: ['./layout-scan-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutScanButtonComponent {
  qrService = inject(QRService);
  cueQrCode = cueQrCode;
  translation = translation;
  sub?: Subscription;
  primaryButton = input(false);

  protected scan() {
    this.qrService.trigger$.next(null);
  }
}
